import React from 'react'

import { CurrentUser } from './generated/CurrentUser'

export interface UserContextInterface {
    currentUser: CurrentUser
}


export const UserContext = React.createContext<UserContextInterface | undefined>(undefined);